let Widget3dsoft = require('./Main.js');

Widget3dsoft.prototype.scrollToTop = function (self, target, options) {

    var settings = $.extend({
        marge: -10,
        duration: 500,
        easing: 'swing'
    }, options);

    var scrollY = '';
    if (target !== undefined) {
        //10
        scrollY = settings.marge + $(target).offset().top + $(self.sClass + ' article').scrollTop() - $(self.sClass + ' article').offset().top;
    } else {
        scrollY = 0;
    }

    $(self.sClass + ' article').animate({
        scrollTop: scrollY
    }, parseInt(settings.duration), settings.easing);

};

Widget3dsoft.prototype.adaptDimensions = function (self) {
    if (self.iAdapDimension < self.iMaxAdapDimension &&
        (
            $(self.sClass).innerHeight() == null || $(self.sClass).innerHeight() == 0 ||
            $(self.sClass + " header").innerHeight() == null || $(self.sClass + " header").innerHeight() == 0 ||
            $(self.sClass + " nav").innerHeight() == null || $(self.sClass + " nav").innerHeight() == 0 ||
            $(self.sClass + " footer").innerHeight() == null || $(self.sClass + " footer").innerHeight() == 0
        )
    ) {
        setTimeout(function () {
            self.iAdapDimension++;
            self.adaptDimensions(self);
        }, 2000);
    } else {
        self.iAdapDimension = 0;

        var heightArticle = $(self.sClass).innerHeight();
        heightArticle -= $(self.sClass + " header").innerHeight();
        heightArticle -= $(self.sClass + " nav").innerHeight();
        heightArticle -= $(self.sClass + " footer").innerHeight();
        $(self.sClass + " article").innerHeight(heightArticle);
    }

};

Widget3dsoft.prototype.headerProfil = function (self) {
    
    if (self.oUser.nom !== null || self.oUser.prenom !== null) {
        $(self.sClass + ' .widget-utilisateur').html(' ( ' + self.oUser.nom + ' ' + self.oUser.prenom + ')');

    }

};

Widget3dsoft.prototype.showErrorInitialisation = function (self) {
    window.onload = function () {
        $(self.sClass).html('Erreur lors de l\'initialisation du widget');
    };
};

Widget3dsoft.prototype.filArianne = function (self, sStep) {
    $('.filArianeStep').removeClass('text-bold');
    $('.' + sStep).addClass('text-bold');
    self.sStep = sStep;

    if (bIEOld3Dsoft) {
        $('.text-right').toggleClass('text-right');
    }

    $(self.sClass + ' .stepAccueil').click(function () {
        self.showFormSearchClient();
    });
    $(self.sClass + ' .stepClient').click(function () {
        if (self.rendezvous.iIdClient != undefined && self.rendezvous.iIdClient != null) {
            self.showFormNewClient(false, false, self.rendezvous.iIdClient, true);
        } else {
            self.showFormNewClient(true);
        }


    });
    $(self.sClass + ' .stepVehicule').click(function () {
        self.showFormVehicule();
    });
    $(self.sClass + ' .stepMotif').click(function () {
        self.showFormInterventions();
    });
    $(self.sClass + ' .stepDate').click(function () {
        self.showFormDate();
    });
    $(self.sClass + ' .stepValidation').click(function () {
        self.showFormValidation(self);
    });
    $(self.sClass + ' .glyphToggleWidget').click(function () {
        $(self.sClass).height() < 60 ? $(self.sClass).css('height', '100%') : $(self.sClass).css('height', '60px');
        $(self.sClass + ' .3dsoft-glyph-sub').toggleClass('glyphicon-collapse-down').toggleClass('glyphicon-collapse-up');
        self.adaptDimensions(self);
    });

};

Widget3dsoft.prototype.completeFooter = function () {
    var self = this;
    var sHtml = '<div class="row text-center padding-top-3">';

    if (self.rendezvous.iIdClient == null) {
        sHtml += '';
    }

    if (self.rendezvous.sNom != null) {
        sHtml += self.strip_tags(self.rendezvous.sNom) + ' ';
    }

    var sNomPrenom = '';
    if (self.rendezvous.sPrenom != null) {
        sNomPrenom += self.strip_tags(self.rendezvous.sPrenom);
    }

    if (self.updateRdvActif) {
        sNomPrenom += '';
    }

    sNomPrenom.substr(0, self.iNbCaracteresNomPrenom);

    if ($(self.sClass + ' .btnValidFoot').html() != undefined) {
        sHtml += ' - ' + $(self.sClass + ' .btnValidFoot').html();
        $(self.sClass + ' .btnValidFoot').remove();
    }

    sHtml += '</div>';
    //$(self.sClass + ' footer').html(self.strip_tags(sHtml));
    $(self.sClass + ' footer').html(sHtml);
};

Widget3dsoft.prototype.strip_tags = function (html) {
    //PROCESS STRING
    if (arguments.length < 3) {
        html = html.replace(/<\/?(?!\!)[^>]*>/gi, '');
    } else {
        var allowed = arguments[1];
        var specified = eval("[" + arguments[2] + "]");
        if (allowed) {
            var regex = '</?(?!(' + specified.join('|') + '))\b[^>]*>';
            html = html.replace(new RegExp(regex, 'gi'), '');
        } else {
            var regex = '</?(' + specified.join('|') + ')\b[^>]*>';
            html = html.replace(new RegExp(regex, 'gi'), '');
        }
    }
    //CHANGE NAME TO CLEAN JUST BECAUSE  
    var clean_string = html;
    //RETURN THE CLEAN STRING
    return clean_string;
};

/**
 * 
 * @param {type} d
 * @returns {Boolean}
 */
Widget3dsoft.prototype.isDate = function (d) {
    // Cette fonction permet de vÃ©rifier la validitÃ© d'une date au format jj/mm/aa ou jj/mm/aaaa
    // Par Romuald

    if (d == "") { // si la variable est vide on retourne faux
        return false;
    }

    var e = new RegExp("^([0-9]{2}|[0-9]{4})\-[0-9]{1,2}\-[0-9]{1,2}$");
    if (!e.test(d)) { // Validate the format
        return false; // Si pas bon, retourne faux
    }
    // On sÃ©pare la date en 3 variables pour vÃ©rification, parseInt() converti du texte en entier
    var a = parseInt(d.split("-")[0], 10); // annÃ©e
    var m = parseInt(d.split("-")[1], 10); // mois
    var j = parseInt(d.split("-")[2], 10); // jour


    // DÃ©finition du dernier jour de fÃ©vrier
    // AnnÃ©e bissextile si annnÃ©e divisible par 4 et que ce n'est pas un siÃƒÂ Ã†â€™Ãƒâ€ Ã¢â‚¬â„¢ÃƒÂ Ã¢â‚¬Â ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ÃƒÂ Ã†â€™ÃƒÂ¢Ã¢â€šÂ¬Ã…Â¡ÃƒÂ Ã¢â‚¬Å¡Ãƒâ€šÃ‚Â¨cle, ou bien si divisible par 400
    var fev = 0;
    if (a % 4 == 0 && a % 100 != 0 || a % 400 == 0)
        fev = 29;
    else
        fev = 28;

    // Nombre de jours pour chaque mois
    var nbJours = new Array(31, fev, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);

    // Enfin, retourne vrai si le jour est bien entre 1 et le bon nombre de jours, idem pour les mois, sinon retourn faux
    return (m >= 1 && m <= 12 && j >= 1 && j <= nbJours[m - 1]);
};

/**
 * Return true if sDate1 is Sup of sDate2
 * @param {type} d1
 * @param {type} d2
 * @returns {Boolean}
 */
Widget3dsoft.prototype.isDateSup = function (sDate1, sDate2) {

    var iYearSDate1 = parseInt(sDate1.split("-")[0], 10); // annee
    var iMonthSDate1 = parseInt(sDate1.split("-")[1], 10); // mois
    var iDaySDate1 = parseInt(sDate1.split("-")[2], 10); // jour

    var iYearSDate2 = parseInt(sDate2.split("-")[0], 10); // annee
    var iMonthSDate2 = parseInt(sDate2.split("-")[1], 10); // mois
    var iDaySDate2 = parseInt(sDate2.split("-")[2], 10); // jour

    return (iYearSDate1 > iYearSDate2 ||
        (iYearSDate1 == iYearSDate2 && iMonthSDate1 > iMonthSDate2) ||
        (iYearSDate1 == iYearSDate2 && iMonthSDate1 == iMonthSDate2 && iDaySDate1 > iDaySDate2));

};


/**
 * 
 * @param {type} iMins
 * @returns {aRes}
 */
Widget3dsoft.prototype.convertMinToHour = function (iMins) {
    var aRes = {
        sHeures: '0',
        sMins: '00'
    };
    aRes.sHeures = parseInt(iMins / 60);
    aRes.sMins = iMins % 60;
    //Add a '0' if it's < 10 (01 02 03 ...)
    if (aRes.sHeures < 10) {
        aRes.sHeures = '0' + aRes.sHeures;
    }
    if (aRes.sMins < 10) {
        aRes.sMins = '0' + aRes.sMins;
    }
    return aRes;
};

/**
 * 
 * @param {type} iMins
 * @returns {aRes}
 */
Widget3dsoft.prototype.convertMinutesToHHMM = function (iMins) {
    var oHM = this.convertMinToHour(iMins);
    return oHM.sHeures + ':' + oHM.sMins;
};

Widget3dsoft.prototype.formatDate = function (sDate) {
    //For IE we have to split the date
    if (sDate !== null && sDate !== undefined && sDate !== '') {
        var sYear = sDate.substr(0, 4);
        var sMonth = parseInt(sDate.substr(5, 2)) - 1; //+1 because the month id begin at 0
        var sDay = sDate.substr(8, 2);
        var sHour = sDate.substr(11, 2);
        var sMin = sDate.substr(14, 2);
        var sSec = sDate.substr(17, 2);

        //Use Date object to convert the date
        var oDate = new Date(sYear, sMonth, sDay, sHour, sMin, sSec);
        var options = {
            weekday: "short", //"narrow", "short", "long".
            year: "numeric", //"numeric", "2-digit". 
            month: "short", //"numeric", "2-digit", "narrow", "short", "long".
            day: "numeric", //"numeric", "2-digit".
        };

        if (sHour != '') {
            options.hour = "2-digit"; //"numeric", "2-digit".
            options.minute = "2-digit"; //"numeric", "2-digit".
            //options.second: "2-digit" //"numeric", "2-digit".
        }

        return oDate.toLocaleDateString(this.sLang.replace('_', '-'), options);
    } else {
        return '';
    }

};

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
if (!Object.keys) {
    Object.keys = (function () {
        'use strict';
        var hasOwnProperty = Object.prototype.hasOwnProperty,
            hasDontEnumBug = !({
                toString: null
            }).propertyIsEnumerable('toString'),
            dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ],
            dontEnumsLength = dontEnums.length;

        return function (obj) {
            if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                throw new TypeError('Object.keys called on non-object');
            }

            var result = [],
                prop, i;

            for (prop in obj) {
                if (hasOwnProperty.call(obj, prop)) {
                    result.push(prop);
                }
            }

            if (hasDontEnumBug) {
                for (i = 0; i < dontEnumsLength; i++) {
                    if (hasOwnProperty.call(obj, dontEnums[i])) {
                        result.push(dontEnums[i]);
                    }
                }
            }
            return result;
        };
    }());

}

Widget3dsoft.prototype.alertMessage = function (self, sMessage) {
    $(self.sClass + ' .widget3Dsoft-message').html(sMessage);
    $(self.sClass + ' .widget3Dsoft-message').show();
    $(self.sClass + ' article').scrollTop(0);
}

Widget3dsoft.prototype.getClient = function () {
    var customer = this.Customer;
    return customer;
};


Widget3dsoft.prototype.getVehicle = function () {
    var vehicle = this.Vehicle;
    return vehicle;

};

Widget3dsoft.prototype.getWorkFile = function () {
    var workfile = this.WorkFile;
    return workfile;

 };